import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { constructQueryParams } from 'utils/query-params-builder';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ResponseProductDto } from '../types/dtos';

export type ProductsQueryParams = BaseQueryParams & {
    website_id?: string;
};

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<PaginatedResponse<ResponseProductDto>, ProductsQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const productsResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.PRODUCTS, _arg));

            if (productsResponse.error) {
                return { error: productsResponse.error };
            }

            const products = productsResponse.data as PaginatedResponse<ResponseProductDto>;

            return {
                data: products,
            };
        },
        providesTags: [{ type: 'products', id: 'GET' }],
    });
